import { resolveDataSource, type ComplianceDataSource } from "./ComplianceDataResolver";

export function resolveChartsSource(params: { hasExtendedData: boolean; hasShortData: boolean }): ComplianceDataSource {
  return resolveDataSource(params);
}

export function buildChartsResolverContext(params: {
  standardCode: string;
  hasExtendedData: boolean;
  hasShortData: boolean;
}) {
  return {
    standardCode: params.standardCode,
    source: resolveChartsSource(params),
    hasExtendedData: !!params.hasExtendedData,
    hasShortData: !!params.hasShortData,
  };
}
